// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ct-entry-shortcut-links[data-v-776e19a3] {\n    display: flex;\n    flex-direction: column;\n    grid-gap: 1rem;\n    gap: 1rem\n}\n@media (min-width: 768px) {\n.ct-entry-shortcut-links[data-v-776e19a3] {\n        grid-gap: 1.5rem;\n        gap: 1.5rem\n}\n}\n@media (min-width: 1280px) {\n.ct-entry-shortcut-links[data-v-776e19a3] {\n        flex-direction: row\n}\n}\n", ""]);
// Exports
module.exports = exports;
